export enum SonoraScenario {
    MailCompose = 1,
    CalendarCompose = 2,
}
